module.exports = __webpack_public_path__ + "img/BE0404501381.e31f67c8.png";